import { createBrowserHistory } from "history";
import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts/Europa-Regular.otf";
import "./index.css";
import "./intl/i18n";
import reportWebVitals from "./reportWebVitals";
import Router from "./routes";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

export const history = createBrowserHistory();
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
